import propTypes from 'prop-types';
import React from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Moment from 'react-moment';
import { connect } from 'react-redux';

const AdminPaymentItem = ({
    auth,
    payment: { _id, bookingid, razorpay_payment_id, razorpay_order_id, amount, date },
}) => {


return (
    <Col>
        <Card border='warning'>
            <Card.Header>
                <b>Date: {<Moment format='YYYY/MM/DD'>{date}</Moment>}</b>
            </Card.Header>
            <Card.Body>
                <table className='room-card-table'>
                    <tbody>
                        <tr>
                            <td>
                                <tr><td>Amount</td><td>{amount}</td></tr>
                                <tr><td>Booking Id</td><td>{bookingid}</td></tr>
                                <tr><td>Order Id</td><td>{razorpay_order_id}</td></tr>
                                <tr><td>Payment Id</td><td>{razorpay_payment_id}</td></tr>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Card.Body>
        </Card>
    </Col>
)};

AdminPaymentItem.propTypes = {
    payment: propTypes.object.isRequired,
    auth: propTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth
});

export default connect(mapStateToProps, { })(AdminPaymentItem);